import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';
import { Subscription } from '@app/store/transport-layer/subscription/subscription';

export type StopSubscriptionResponse = Subscription;
export function stopSubscriptionAPI(workspaceId: string) {
  return requestApi<StopSubscriptionResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription/stop`),
    method: 'POST',
    credentials: true,
  }).then((response) => response.data);
}
